import "../../../assets/style/Capability.css";

import Topbar from "../../../component/Topbar/Topbar"
import Footer from "../../../component/Footer/Footer"

import arrow from "../../../assets/icon/arrowRight.svg";
import upload from "../../../assets/icon/upload.svg";
import loading from "../../../assets/icon/loading.svg";
import x from "../../../assets/icon/x.svg";

import previewOCR from "../../../assets/photo/previewOCR.jpg";

import Dropzone from 'react-dropzone'
import { useState } from "react";
import { Link } from "react-router-dom";


function OCR(params) {
    const [exampleTarget, setExampleTarget] = useState(false)
    const [fileTarget, setFileTarget] = useState([])
    const [spamClick, setSpamClick] = useState(false);
    const [errorTarget, setErrorTarget] = useState(false)

    function formatBytes(bytes) {
        if (bytes < 1024) return bytes + ' Bytes';
        else if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(2) + ' KB';
        else if (bytes < 1024 * 1024 * 1024) return (bytes / (1024 * 1024)).toFixed(2) + ' MB';
        else return (bytes / (1024 * 1024 * 1024)).toFixed(6) + ' GB';
    }

    const submitOCR = () => {
        setSpamClick(true)
        if(exampleTarget){
            setSpamClick(false);
            const jsonString = JSON.stringify({"result":{"success":true,"result":[[{"id":"2024-8-21_EIF4DjyJcuxEdo4"},{"header":{"bank_name":"mandırı","owner_name":"","owner_address":"","account_number":"","account_branch":"","account_type":"","period":"","currency":""},"transactions":[{"balance":{"account_branch":"","account_type":"","period":"1/10,719.00","currency":""},"trx_date":"13/10","trx_mutation_cr":"117,030.00","trx_note":"Sdr Maju Kaya Fk"},{"balance":"139,318.00","trx_date":"16/10","trx_mutation_cr":"28,909.00","trx_note":"MIDI WARUNG FTSCY / WSID950310292 6019007561531626"},{"balance":"14,318.00","trx_date":"13/10","trx_mutation_cr":"2,500.00","trx_note":"FIKRI FAST CR TRANSFER DR 2 MURUNG 844308527"},{"balance":"14,318.00","trx_date":"22/10","trx_mutation_cr":"300,000.00","trx_note":"FIKRI FAST CR TRANSFER DR 2 ALFAMRT - DEBIT"},{"balance":"14,318.00","trx_date":"25/10","trx_mutation_cr":"300,000.00","trx_note":"SWIHURY ZM DI ATM ZMDI ATM 12123 / ADAMSPAY / NEGIRINE"},{"balance":"103,318.00","trx_date":"25/10","trx_mutation_cr":"4,100.00","trx_note":"Incom Sinabur k ZMDI ATMBLANK FTSCY WSID950310291"},{"balance":"103,318.00","trx_date":"25/10","trx_mutation_cr":"4,100.00","trx_note":"TRANSFER DR 2 ZMDI ATMBLANK FTSCY / WSID950310291"},{"balance":"103,318.00","trx_date":"13/10","trx_mutation_cr":"200,000.00","trx_note":"SWIHURY SEJAH MANDIRI - 22/10/95031/00000"},{"balance":"103,318.00","trx_date":"13/10","trx_mutation_cr":"200,000.00","trx_note":"IMAM SEJAH MANDIRI - 22/10/95031/00000"},{"balance":"125,318.00","trx_date":"13/10","trx_mutation_cr":"43,410.00","trx_note":"IMDIRI - 22/10/95031/00000"},{"balance":"145,318.00","trx_date":"13/10","trx_mutation_cr":"500,000.00","trx_note":"IMDIRI - 22/10/95031/00000"},{"balance":"153,318.00","trx_date":"13/10","trx_mutation_cr":"17,500.00","trx_note":"IM DI - 22/10/95031/00000"},{"balance":"120,318.00","trx_date":"01/10","trx_mutation_cr":"12,316.00","trx_note":"IM DI - 22/10/95031/00000"},{"balance":"54,018.00","trx_date":"01/10","trx_mutation_cr":"300,000.00","trx_note":"IM DI - 22/10/95031/00000"},{"balance":"5,310,318.00","trx_date":"01/10","trx_mutation_cr":"530,000.00","trx_note":"TRANSFER DR 2 WARUNG / ATM - DEBIT"},{"balance":"5,310,318.00","trx_date":"01/10","trx_mutation_cr":"600,000.00","trx_note":"DR 2 DOCKRI M -"},{"balance":"5,314,318.00","trx_date":"01/10","trx_mutation_cr":"3,218.00","trx_note":"DR 2 DOCKRI M -"},{"balance":"5,318.00","trx_date":"01/10","trx_mutation_cr":"3,218.00","trx_note":"DR 2 DOCKRI FAST CR"},{"balance":"5,318.00","trx_date":"01/10","trx_mutation_cr":"1,300.00","trx_note":"TRANSFER DR 2 SITIMULA - 22/10/95031/00000"}],"summary":{"beginning_balance":"117,318.00","credit_mutation":"","debit_mutation":"","ending_balance":""}}]]}});
            const blob = new Blob([jsonString], { type: "application/json" });
            const url = URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = "result.json"; // Nama file yang diinginkan
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        } else if (fileTarget.length === 0){
            setSpamClick(false)

            const link = document.createElement("a");
            link.href = "#errorTarget";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setErrorTarget(true);
            setTimeout(() => {
                setErrorTarget(false)
            }, 4000);
        } 
        setSpamClick(false);
        // else {
        //     const formdata = new FormData();
        //     formdata.append("image", fileTarget[0]);
    
        //     const requestOptions = {
        //     method: "POST",
        //     body: formdata,
        //     redirect: "follow"
        //     };
    
        //     fetch(`${process.env.REACT_APP_BE}ocr/convert`, requestOptions)
        //     .then((response) => {
        //         if(response.ok) return response.json()
        //         else{
        //             alert(`Oops Sorry, server is busy... please Reload :) `);
        //             setSpamClick(false);
        //         }
        //     })
        //     .then((result) => {
        //         // console.log(result)
        //         if(result !== undefined){
        //             const jsonString = JSON.stringify(result);
        //             const blob = new Blob([jsonString], { type: "application/json" });
        //             const url = URL.createObjectURL(blob);
        
        //             const link = document.createElement("a");
        //             link.href = url;
        //             link.download = "result.json"; // Nama file yang diinginkan
        //             document.body.appendChild(link);
        //             link.click();
        //             document.body.removeChild(link);
        //             URL.revokeObjectURL(url);
        //         }

        //         setSpamClick(false)
        //     })
        //     .catch((error) => {
        //         // console.error(error)
        //         alert(`Oops Sorry, server is busy... please Reload :) `);
        //         setSpamClick(false);
        //     });
        // }

    }

    return(
        <>
            <Topbar/>

            <section className="capability">

                <div className="breadcrumbDemo">
                    <Link to={"/"}>Home</Link>
                    <img src={arrow} alt="arrow"></img>
                    <Link to={"/demo"}>Demo</Link>
                    <img src={arrow} alt="arrow"></img>
                    <p style={{color: '#25874C'}}>OCR</p>
                </div>

                <div className="contentCapability" id="errorTarget">
                    <p className="titleCapability">See How Optical Character Recognition Transforms Businesses</p>
                    <div className="kotakCapability"></div>
                    <p className="textCapability">Convert printed text into digital format with our OCR feature. Seamlessly transform e-statements into editable and searchable data, enhancing workflow efficiency and data accessibility.</p>
                </div>

                <div className="mainCapability">

                    <div className="inputCapability">
                        <div className={errorTarget ? "textAreaCapability shadowCapability shadowErrorCapability" : "textAreaCapability shadowCapability"}>                       
                            <label>Media Upload</label>
                            

                            <Dropzone onDrop= {acceptedFiles => {
                                setFileTarget( acceptedFiles.map(file => Object.assign( file, {
                                    // preview: URL.createObjectURL(file)
                                })) )
                            }}
                            accept={{'image/*': [], 'application/pdf': []}}
                            >
                                {({getRootProps, getInputProps}) => (
                                    <section onClick={() => {setFileTarget([]); setExampleTarget(false)}}>
                                        <div className="uploadCapability" {...getRootProps()}>
                                            <input {...getInputProps()} />
                                            <img src={upload} alt="up"/>
                                            <p>Drag your file(s) to start uploading</p>
                                            <div className="orUpload">
                                                <div className="garisPutih"></div>
                                                <p>OR</p>
                                                <div className="garisPutih"></div>
                                            </div>
                                            <button className="buttonGreenFill">Browser file</button>
                                        </div>
                                    </section>
                                )}
                            </Dropzone>

                            {fileTarget.map((item, index) => (
                                <div key={index} className="itemUploadCapability">
                                    <div className="itemInfoCapability">
                                        <div className="itemDetailInfoCapability">
                                            {/* <img src={item.preview} width={120}></img> */}
                                            <div className="itemKeteranganCapability">
                                                <p className="itemNameCapability">{item.name}</p>
                                                <p className="itemSizeCapability">{formatBytes(item.size)}</p>
                                            </div>
                                        </div>
                                        <img src={x} onClick={() => {setFileTarget([]); setExampleTarget(false)}} style={{cursor: 'pointer'}} alt="up"/>
                                    </div>
                                </div>
                            ))}

                            <p className="noMargin"
                                style={{
                                color: '#bd2f2f',
                                opacity: errorTarget ? "1" : "0", 
                                transition: "all .5s", 
                                }}>
                                    Please input your file :))
                            </p>

                        </div>
                        <div className="textAreaCapability">   
                            <label>Copy Example</label>
                            <img src={previewOCR} width={120} alt="up"/>
                            <button className="buttonSubmit" style={{width: 'max-content'}} onClick={() => { setFileTarget([{preview: previewOCR, name: 'target.jpg', size: 0}]); setExampleTarget(true)}}>Copy Example</button>
                        </div>
                    </div>

                    <div className="submitCapability">
                        <button className="buttonSubmit" style={{width: 'max-content'}} onClick={() => submitOCR()} disabled={spamClick}>Submit</button>
                        {spamClick === true && (
                            <img src={loading} width={60} alt="up"></img>
                        )}
                    </div>

                    {/* <div>
                        <div className="textAreaCapability">                    
                            <label>Result</label>
                            <div className="resultCapability">
                                <p></p>
                            </div>
                        </div>
                    </div> */}

                </div>



            </section>

            <Footer/>

        </>
    )
}

export default OCR